import React from 'react';
import { AiFillPhone } from "react-icons/ai";
import { MdEmail } from "react-icons/md";

const Head = () => {
    return (
        <>
            <section className='head'>
                <div className='container d_flex'>
                    <div className='left row flex'>
                        <i><AiFillPhone /></i>
                        <label> +88012 3456 7894</label>
                        <i><MdEmail /></i>
                        <label> support@logistic.com</label>
                    </div>
                    <div className='right row RText'>
                        <label>Theme FAQ"s</label>
                        <label>Need Help?</label>
                        <span>🏳️‍⚧️</span>
                        <label>EN</label>
                        <span>🏳️‍⚧️</span>
                        <label>USD</label>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Head;